// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"V2-z","dimensionLabel":"W2-z","styleChooserControlWrapper":"X2-z","styleChooserControl":"Y2-z","disabled":"Z2-z","giftCard":"_2-z","styleChooserText":"a3-z"};